export const PARKING_PASS_KIND = 'car';
export const MODERATOR_PASS_KIND = 'virtual';
